import { PermissionLevel } from '../utils/DrivePermission/permission'

export enum ObjectType {
    FILE = 'file',
    FOLDER = 'folder',
}

export const IMAGE_EXTENSIONS = [
    'jpg',
    'jpeg',
    'png',
    'gif',
    'webp',
    'JPG',
    'heic',
    'HEIC',
]
export const VIDEO_EXTENSIONS = ['mp4', 'mov', 'avi', 'wmv', 'flv', 'mkv']

export interface CreateStarredObjectParams {
    starred_object_key: string
    starred_object_name: string
    starred_object_size: number
    starred_object_last_modified: string | null
    starred_object_type: ObjectType
    employee_uuid: string
    employee_uuid_2: string
}

export interface RenameObjectParams {
    old_object_key: string // Old key
    new_object_key: string // New key
}

export interface RemoveStarredParams {
    uuid: string
    objectName: string
}

export interface StarredObjectsResponse {
    starred_object_id: number
    starred_object_key: string
    starred_object_name: string
    starred_object_size: number
    starred_object_last_modified: string | null
    starred_object_type: ObjectType
    employee_uuid: string
    owner_email_company: string
}

export interface CreateRecentObjectParams {
    recent_object_key: string
    recent_object_name: string
    recent_object_size: number
    recent_object_last_modified: string
    employee_uuid: string
    employee_uuid_2: string
}

export interface RecentObjectResponse {
    recent_object_id: number
    recent_object_key: string
    recent_object_name: string
    recent_object_size: number
    recent_object_last_modified: string
    recent_object_last_view: string
    employee_uuid: string
    owner_email_company: string
}

export type RecentObjectwithCursor = {
    objects: RecentObjectResponse[]
    next_cursor: string | null
    has_more: boolean
}

export interface File {
    Key: string
    Size: number
    LastModified: string
    Permission?: PermissionLevel
}

export interface Metadata {
    content_type: string
    size: number
    last_modified: string
}

export interface Folder {
    Prefix: string
    Permission?: PermissionLevel
    FolderName?: string
}

export type ThumbnailResponse = {
    thumbnail: string
    available: boolean
}

export interface SharedLinkResponse {
    share_link_id: number
    share_link_token: string
    share_object_key: string
    share_object_type: ObjectType
    share_is_public: boolean
    share_permission_level: PermissionLevel
    share_link_created_at: string
    share_link_expired_at: string
    share_link_created_by: string
}

export interface ShareLinkParams {
    share_object_key: string
    share_object_type: ObjectType
    share_is_public: boolean
    share_permission_level: PermissionLevel
    share_link_created_by: number
    share_with_employees?: number[]
    share_with_department?: number[]
}

export interface GetObjectPermissionLevelRow {
    current_path: string
    share_permission_level: PermissionLevel
    share_object_type: string
    share_link_token: string
    share_link_id: number
    permission_rank: number
}

export interface OwnerResponse {
    owner_id: number
    owner_name: string
    owner_email: string
}

export interface RecipientResponse {
    share_recipient_id: number
    share_link_id: number
    share_permission_level: PermissionLevel
    recipient_id: number
    recipient_name: string
    recipient_email: string
    share_recipient_type: string
    share_is_public?: boolean
}

export interface ShareRecipientResponse {
    owner: OwnerResponse
    recipient_list: RecipientResponse[]
}

export interface EditShareRecipientParams {
    share_recipient_id: number
    share_object_key: string
    share_object_type: ObjectType
    share_permission_level: PermissionLevel
    recipient_id: number
    share_recipient_type: 'employee' | 'department' | 'public'
    revoke?: boolean
    share_link_created_by?: number
}

export type EmployeeNamesResponse = {
    employee_name: string
    employee_uuid: string
}

interface DownloadItem {
    object_type: ObjectType
    object_key: string
}

export interface DownloadMultipleFilesParams {
    items: DownloadItem[]
    prefix: string
    zipName: string
}
